enum Brand {
  ABRITEL = 'abritel',
  BOOKABACH = 'bookabach',
  EXPEDIA = 'expedia',
  FEWO_DIREKT = 'fewodirekt',
  HOTELS = 'hotels',
  STAYZ = 'stayz',
  VRBO = 'vrbo',
  WOTIF = 'wotif',
}

export { Brand };
